import {
  CardActionArea,
  CircularProgress,
  ClickAwayListener,
  Divider,
  Icon,
  Checkbox,
  Modal,
  styled,
  SwipeableDrawer,
  tableRowClasses,
} from "@mui/material";
import getLPTheme from "../getLPTheme";
import BottomNavigation from "@mui/material/BottomNavigation";
import Puller from "./Puller";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ReorderIcon from "@mui/icons-material/Reorder";
import MapIcon from "@mui/icons-material/Map";
import SpaIcon from "@mui/icons-material/Spa";
import FilterListIcon from "@mui/icons-material/FilterList";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Avatar from "@mui/material/Avatar";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import { GlobalDataContext } from "../index";
import RestoreIcon from "@mui/icons-material/Restore";
import FavoriteIcon from "@mui/icons-material/Favorite";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import TableCell from "@mui/material/TableCell";
import { useMediaQuery } from "@mui/material";
import FilterIcon from "../images/filter_icon";
import { useTheme } from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";
import PlaceIcon from "@mui/icons-material/Place";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Badge from "@mui/material/Badge";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { DateTime } from "luxon";
import Chip from "@mui/material/Chip";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import dayjs, { Dayjs } from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Link from "@mui/material/Link";
import AddTaskIcon from "@mui/icons-material/AddTask";
import { useContext, useEffect, useState, useRef } from "react";
import { SvgIcon } from "@mui/material";

import { AuthContext } from "../index";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import axios from "axios";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Stack from "@mui/material/Stack";
import { compareDesc } from "date-fns";
import Container from "@mui/material/Container";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { grey } from "@mui/material/colors";
import parsePhoneNumber, {
  AsYouType,
  isPossiblePhoneNumber,
  isValidPhoneNumber,
} from "libphonenumber-js";
import React from "react";

const AuthBySMSForm = ({
  setButton,
  setButtonClick,
  onLoginSuccess = () => {},
}) => {
  const navigate = useNavigate();
  const { id: userId, onLogin, onLogout } = useContext(AuthContext);
  const { media } = useContext(GlobalDataContext);

  const STATUSES = {
    AUTH_BY_SMS_INITIAL: "AUTH_BY_SMS_INITIAL",
    SEND_SMS_START: "SEND_SMS_START",
    SEND_SMS_SUCCESS: "SEND_SMS_SUCCESS",
    SEND_SMS_FAILRE: "SEND_SMS_FAILRE",
    VERIFY_SMS_START: "VERIFY_SMS_START",
    VERIFY_SMS_SUCCESS: "VERIFY_SMS_SUCCESS",
    VERIFY_SMS_FAILURE: "VERIFY_SMS_FAILURE",
  };

  const DEFAULT_FORM = {
    phone: new AsYouType().input("+7"),
    phoneErrorLabel: "",
    sms: "",
    smsError: "",
    status: STATUSES.AUTH_BY_SMS_INITIAL,
    offerAndPolicyChecked: false,
    personalDataChecked: false,
  };
  const [form, setForm] = useState(DEFAULT_FORM);

  const getButtonConfig = () => {
    const DEFAULT_CONFIG = {
      text: "",
      loading: false,
      action: () => {},
    };

    switch (form.status) {
      case STATUSES.AUTH_BY_SMS_INITIAL:
        return {
          text: "Отправить код",
          action: handleSendSMS,
        };
      case STATUSES.SEND_SMS_START:
        return {
          text: "Отправка кода...",
          loading: true,
          action: () => {},
        };
      case STATUSES.SEND_SMS_SUCCESS:
        return {
          text: "Подтверждение входа",
          loading: false,
          action: handleVerifySMS,
        };
      case STATUSES.SEND_SMS_FAILRE:
        return { ...DEFAULT_CONFIG, text: "OK", action: handleRetry };
      case STATUSES.VERIFY_SMS_START:
        return { ...DEFAULT_CONFIG, text: "Подтверждение...", loading: true };
      case STATUSES.VERIFY_SMS_FAILURE:
        return { ...DEFAULT_CONFIG, text: "OK", action: handleRetry };

      default:
        return DEFAULT_CONFIG;
    }
  };

  useEffect(() => {
    if (form.status == STATUSES.VERIFY_SMS_SUCCESS) {
      // onLogin
      onLoginSuccess();
      navigate("/");
    }
  }, [form.status]);

  const handleRetry = () => {
    setForm(DEFAULT_FORM);
  };

  const handleSendSMS = async () => {
    // validate phone number
    const parsedPhone = parsePhoneNumber(form.phone, "RU");

    if (!parsedPhone || !parsedPhone.isValid()) {
      setForm((ps) => ({
        ...ps,
        phoneErrorLabel: "Некорректный номер телефонa",
      }));
      return;
    }

    setForm((ps) => ({ ...ps, phoneErrorLabel: "" }));

    // disble phone field
    setForm((ps) => ({ ...ps, status: STATUSES.SEND_SMS_START }));
    setButton((ps) => ({ ...ps, text: "Получить смс", loading: true }));

    try {
      const sendSmsResp = await axios.post("/api/v1/auth/sms", {
        phone: parsedPhone.number,
        role: "specialist",
      });

      setForm((ps) => ({ ...ps, status: STATUSES.SEND_SMS_SUCCESS }));
    } catch (err) {
      setForm((ps) => ({ ...ps, status: STATUSES.SEND_SMS_FAILRE }));
      return;
    }
  };

  const handleVerifySMS = async () => {
    // if sms is valid

    const url = "/api/v1/auth/sms/verify";

    try {
      setForm((ps) => ({ ...ps, status: STATUSES.VERIFY_SMS_START }));
      const resp = await axios.post(url, {
        phone: parsePhoneNumber(form.phone, "RU").number,
        sms: form.sms,
        role: "specialist",
      });

      onLogin(resp.data.jwt);
      setForm((ps) => ({ ...ps, status: STATUSES.VERIFY_SMS_SUCCESS }));
    } catch (e) {
      setForm((ps) => ({ ...ps, status: STATUSES.VERIFY_SMS_FAILURE }));
    }
  };

  return (
    <Stack
      sx={{
        justifyContent: "center",
        alignItems: "center",
        pr: "20px",
        pl: "20px",
      }}
      spacing={3}
    >
      <Stack>
        <Typography
          align={"left"}
          fontSize={"10px"}
          sx={{ color: "rgb(0 0 0/ 0.7)" }}
        >
          Номер телефона
        </Typography>
        <TextField
          id="phone"
          name="phone"
          disabled={form.status != STATUSES.AUTH_BY_SMS_INITIAL}
          value={form.phone}
          type={"string"}
          onChange={(event) => {
            if (event.target.value.length < 2) return;
            setForm((ps) => ({
              ...ps,
              phone: new AsYouType().input(event.target.value),
              phoneErrorLabel: "",
            }));
          }}
        />
      </Stack>
      {form.status == STATUSES.SEND_SMS_SUCCESS ? (
        <Stack>
          <Typography
            align={"left"}
            fontSize={"10px"}
            sx={{ color: "rgb(0 0 0/ 0.7)" }}
          >
            Код из SMS
          </Typography>
          <TextField
            id="sms"
            name="sms"
            pattern={"[0-9]*"}
            inputmode={"numeric"}
            disabled={form.status != STATUSES.SEND_SMS_SUCCESS}
            value={form.sms}
            // autoFocus
            onChange={(event) => {
              if (event.target.value.length > 4) return;

              setForm((pS) => ({ ...pS, sms: event.target.value }));
            }}
          />
        </Stack>
      ) : null}
      {form.phoneErrorLabel ? (
        <Alert severity="warning">Некорректный номер телефона</Alert>
      ) : null}
      {form.status == STATUSES.SEND_SMS_FAILRE ? (
        <Alert severity="warning">
          К сожалению, что-то пошло не так. Если вы отправляли смс код за
          последние 24 часа, дождидесь и введите его
        </Alert>
      ) : null}
      {form.status == STATUSES.VERIFY_SMS_FAILURE ? (
        <Alert severity="warning">Не удалось подтвердить телефон</Alert>
      ) : null}
      <Button
        variant={"contained"}
        size={"medium"}
        disabled={
          form.status == STATUSES.AUTH_BY_SMS_INITIAL &&
          (!form.offerAndPolicyChecked || !form.personalDataChecked)
        }
        loading={getButtonConfig().loading}
        loadingIndicator={getButtonConfig().text}
        // startIcon={ getButtonConfig().loading ? <CircularProgress size={'20px'}/> : null}
        fullWidth={false}
        sx={{
          borderRadius: "25px",
          ontSize: { sm: "20px", xs: "16px" },
          mt: 2,
          width: "250px",
        }}
        onClick={getButtonConfig().action}
      >
        {getButtonConfig().text}
      </Button>
      {form.status == STATUSES.AUTH_BY_SMS_INITIAL ? (
        <>
          <Button
            variant={"contained"}
            size={"medium"}
            fullWidth={false}
            sx={{
              borderRadius: "25px",
              ontSize: { sm: "20px", xs: "16px" },
              mt: 2,
              width: "250px",
            }}
            onClick={() => {
              const parsedPhone = parsePhoneNumber(form.phone, "RU");

              if (!parsedPhone || !parsedPhone.isValid()) {
                setForm((ps) => ({
                  ...ps,
                  phoneErrorLabel: "Некорректный номер телефонa",
                }));
                return;
              }

              setForm((ps) => ({ ...ps, phoneErrorLabel: "" }));

              setForm((ps) => ({ ...ps, status: STATUSES.SEND_SMS_SUCCESS }));
            }}
          >
            Ввести код
          </Button>
          <Typography
            align={"left"}
            fontSize={"10px"}
            sx={{ color: "rgb(0 0 0/ 0.7)", marginTop: "2px !important" }}
          >
            если отправляли в течение 24 часов
          </Typography>
        </>
      ) : null}
      {form.status == STATUSES.AUTH_BY_SMS_INITIAL ? (
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"center"}
          sx={{ pt: 2 }}
        >
          <Checkbox
            checked={form.offerAndPolicyChecked}
            onChange={(event) => {
              setForm((prevState) => ({
                ...prevState,
                offerAndPolicyChecked: event.target.checked,
              }));
            }}
          />
          <Typography align={"left"} sx={{ fontSize: "12px", color: "gray" }}>
            Я принимаю условия{" "}
            <Typography
              onClick={() => {
                window.location = "https://bimclinics.ru/offer";
              }}
              sx={{
                fontSize: "12px",
                textDecoration: "underline",
                display: "inline",
              }}
            >
              Оферты
            </Typography>{" "}
            и{" "}
            <Typography
              onClick={() => {
                window.location = "https://bimclinics.ru/policy";
              }}
              sx={{
                fontSize: "12px",
                textDecoration: "underline",
                display: "inline",
              }}
            >
              Политики обработки персональных данных
            </Typography>
          </Typography>
        </Stack>
      ) : null}
      {form.status == STATUSES.AUTH_BY_SMS_INITIAL ? (
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Checkbox
            checked={form.personalDataChecked}
            onChange={(event) => {
              setForm((prevState) => ({
                ...prevState,
                personalDataChecked: event.target.checked,
              }));
            }}
          />
          <Typography align={"left"} sx={{ fontSize: "12px", color: "gray" }}>
            Я даю{" "}
            <Typography
              onClick={() => {
                window.location = "https://bimclinics.ru/consent";
              }}
              sx={{
                fontSize: "12px",
                textDecoration: "underline",
                display: "inline",
              }}
            >
              Согласие на обработку моих персональных данных
            </Typography>
          </Typography>
        </Stack>
      ) : null}
      {form.status == STATUSES.AUTH_BY_SMS_INITIAL ? (
        <Typography sx={{ fontSize: "10px", color: "gray" }}>
          Нажимая «Отправить код», вы подтверждаете, что номер телефона
          принадлежит вам, и соглашаетесь на использование простой электронной
          подписи (ввод кода из SMS) для подписания документов в Сервисе
        </Typography>
      ) : null}
    </Stack>
  );
};

export default AuthBySMSForm;
